import { HeatWaveIcon } from './HeatWaveIcon';

/**
 * author: Michael Irigoyen
 * id 8AD5E52C-320C-4071-B891-552B4D71A42C
 * name heat-wave
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/heat-wave.svg
 * tags
 * - Home Automation 
 * - Weather 
 * - Agriculture 
 */
export const WarmthIcon = HeatWaveIcon;
export default WarmthIcon